import { Route, Routes } from "react-router-dom";

import ClientsPage from "../../../pages/module-pages/support/clients/ClientsPage";
import CallsPage from "../../../pages/module-pages/support/calls/CallsPage";
import TicketsPage from "../../../pages/module-pages/support/tickets/TicketsPage";
import ChatPage from "../../../pages/module-pages/support/chat/ChatPage";
import CentreConnaissance from "../../../pages/module-pages/support/knowledge/CentreConnaissance";
import KnowledgeListPage from "../../../pages/module-pages/support/knowledge/KnowledgeListPage";
import ImportKnowledgeListPage from "../../../pages/module-pages/support/knowledge/ImportKnowledgeListPage";
import KnowledgeUpdatePage from "../../../pages/module-pages/support/knowledge/KnowledgeUpdatePage";
import ClientNav from "./features/CientNav";
import AuditLogSearchPage from "../../../pages/module-pages/support/audit-logs/AuditLogSearchPage";
import TasksPage from "../../../pages/module-pages/support/tasks/TasksPage";

export default function SupportNav() {
  return (
    <Routes>
      <Route path="/clients/*" element={<ClientNav />} />
      <Route path="/audit-logs" element={<AuditLogSearchPage />} />
      <Route path="/calls" element={<CallsPage />} />
      <Route path="/tickets" element={<TicketsPage />} />
      <Route path="/tasks" element={<TasksPage />} />

      <Route path="/chat" element={<ChatPage />} />
      <Route path="/knowledge" element={<CentreConnaissance />} />
      <Route path="/knowledge/admin" element={<KnowledgeListPage />} />
      <Route path="/knowledge/admin/import" element={<ImportKnowledgeListPage />} />
      <Route path="/knowledge/admin/edit/:id" element={<KnowledgeUpdatePage />} />
    </Routes>
  );
}
